import React from "react"

import styles from "./CarouselArrow.module.scss"

const CarouselArrow = ({ position, customClass, onClick, ...rest }) => {
  /*
  const {
    onMove,
    carouselState: { currentSlide, deviceType },
  } = rest
  */
  return (
    <button
      className={`${styles.element} ${customClass}`}
      onClick={() => onClick()}
    >
      <img
        src="/svg/arrow.svg"
        width="26"
        height="26"
        className={position === "left" ? styles.left : ""}
        alt=""
      />
      {position === "left" && (
        <span className="screen-reader-text">Edellinen</span>
      )}
      {position === "right" && (
        <span className="screen-reader-text">Seuraava</span>
      )}
    </button>
  )
}

CarouselArrow.defaultProps = {
  position: "right",
}

export default CarouselArrow
